import { ConditionalWrapper } from '~/components/ConditionalWrapper/ConditionalWrapper';
import { useRegistrationCategories } from '../hooks/useRegistrationCategories';
import { usePartialUpdateCompetitionMutation } from '../../mutations';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { QualificationCard } from './qualification-card';
import { Tooltip } from '~/components/Tooltip/Tooltip';
import { Button } from '~/components/Button/Button';
import { useCompetitionQuery } from '../../queries';
import { Panel } from '~/components/Panel/Panel';
import { useNavigate } from 'react-router';
import { useParams } from '~/hooks/useParams';
import { Link } from '~/components/Link/Link';
import { Fragment } from 'react/jsx-runtime';
import { idParamSchema } from '~/schemas';
import { toast } from 'react-toastify';

export function QualificationForm() {
  const partialUpdateMutation = usePartialUpdateCompetitionMutation();
  const navigate = useNavigate();

  const { id } = useParams(idParamSchema.parse);

  const { data: competition, isLoading: loadingCompetition } = useCompetitionQuery(id);
  const { categories, isRefetching, isLoading, noWeightClass } = useRegistrationCategories();

  async function handlePublish() {
    await partialUpdateMutation.mutateAsync({ id, payload: { state: 'PUBLISHED' } });
    toast.success('Tävlingen har publicerats');
    navigate(`/competitions/${id}`);
  }

  return (
    <Fragment>
      <PageLayout.SubHeading>Kvalgränser</PageLayout.SubHeading>

      {!isLoading && !isRefetching && !loadingCompetition ? (
        <Fragment>
          {!categories.length && (
            <Panel variant="informative" size="sm">
              <p>
                För att kunna publicera en tävling behöver du först välja vilka tävlingstyper samt ålderskategorier
                tävlingen involverar.
              </p>
              <p>Därefter kan du sätta kvalgränser för respektive kategori och viktklass.</p>
            </Panel>
          )}

          {noWeightClass && categories.length > 0 && (
            <Panel variant="informative" size="sm" style={{ marginBottom: 'var(--size-4)' }}>
              <p>
                Denna tävling tillåter anmälan utan viktklass. Kvalgränser och viktklasser hanteras inte för dessa
                kategorier.
              </p>
            </Panel>
          )}

          <div style={{ display: 'flex', gap: 'var(--size-3)', flexDirection: 'column' }}>
            {categories.map((category, index) => (
              <QualificationCard
                category={category}
                isOpen={index === 0 && !noWeightClass}
                disabled={!!noWeightClass}
                key={`rc-${index}`}
              />
            ))}
          </div>

          <Button.Group align="right">
            <Link to={`/competitions/${id}/edit`}>
              <Button type="button" variant="secondary">
                Tillbaka till redigera tävling
              </Button>
            </Link>

            <ConditionalWrapper
              wrap={child => (
                <Tooltip title="Du kan endast publicera nyligen skapade tävlingar" as="span">
                  {child}
                </Tooltip>
              )}
              condition={competition?.state !== 'CREATED'}
            >
              <Button
                disabled={competition?.state !== 'CREATED' || !categories.length}
                onClick={handlePublish}
                variant="primary"
                type="button"
              >
                Publicera tävling
              </Button>
            </ConditionalWrapper>
          </Button.Group>
        </Fragment>
      ) : (
        'Laddar...'
      )}
    </Fragment>
  );
}
